module.exports = __webpack_public_path__ + "static/media/businessPortfolio.5636f2a8.svg";